// extracted by mini-css-extract-plugin
export default {"commentSelect":"styles_commentSelect__cNFPn","commentSelectSelection":"styles_commentSelectSelection__CmrWw","fadeIn":"styles_fadeIn__vG3CL"};